var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 403,
    viewBox: "0 0 403 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_467_244)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 266,
    r: 223,
    fill: "#624873"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 114.5,
    r: 114.5,
    fill: "#9367B1",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_467_244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 403,
    height: 403,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinUs);
export default __webpack_public_path__ + "static/media/joinUs.d526cf51bf99e88f6d039d57707d5d88.svg";
export { ForwardRef as ReactComponent };